import React, { useEffect, useState } from 'react';
import Pagination from 'components/molecules/Pagination/Pagination';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { deletePattern, getTemplates } from 'services/templateService';
import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent';
import PatternCardItem from 'components/molecules/PatternCardItem/PatternCardItem';
import { TemplateRulesList } from 'interfaces/templates';
import { Box } from '../../atoms/AppBox';
import AppInput from '../../atoms/AppInput/AppInput';
import { useNavigate } from 'react-router-dom';
import StatusToast from 'components/molecules/StatusToast/StatusToast';

export default function PatternList() {
    const { apiToken } = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({
        totalItems: 0,
        page: 1,
        itemsPerPage: 10,
    })

    const [templates, setTemplates] = useState<TemplateRulesList[]>([])
    const [messageError, setMessageError] = useState('')
    const [type, setType] = useState<'error' | 'success' | 'loading'>('error')

    const changePage = (page: number) => {
        setPagination({ ...pagination, page })
    }

    const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const value = (e.target as HTMLInputElement).value
        if (e.key === 'Enter') {
            fetchData(value)
        }
    }

    const fetchData = async (template = '') => {
        setLoading(true)
        const templates = await getTemplates(pagination.page, template)
        setTemplates(templates.items)
        setPagination({
            page: templates.page,
            totalItems: templates.totalItems,
            itemsPerPage: templates.size,
        })
        setLoading(false)
    }

    const deleteTemplate = async (id: number) => {
        try {
            setLoading(true)
            await deletePattern(id)
            setType('success')
            setMessageError('Plantilla eliminada satisfactoriamente')
            fetchData()
        } catch (error) {
            setType('error')
            setMessageError(
                typeof error === 'object' &&
                    error !== null &&
                    'message' in error
                    ? String((error as { message: unknown }).message)
                    : 'Error al eliminar la plantilla'
            )
        }
        setTimeout(() => {
            setMessageError('')
        }, 3000)
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [apiToken, pagination.page])

    return (
        <div className="">
            {messageError && <StatusToast title={messageError} type={type} />}
            <Box>
                {loading && <LoaderTransparent />}
                <div className="w-2/5">
                    <AppInput
                        placeholder={'Buscar'}
                        onKeyDown={handleSearch}
                        showSearchIcon
                    />
                </div>
                <div className=" flex flex-col justify-between h-full mt-8">
                    <div
                        className="overflow-y-auto"
                        style={{ height: '500px' }}
                    >
                        {templates.length > 0 ? (
                            templates.map((template, index) => (
                                <PatternCardItem
                                    key={index}
                                    id={template.id}
                                    title={template.name}
                                    countRules={template.count_groups}
                                    countChutes={template.count_chutes}
                                    nameWarehouse={template.warehouse_name}
                                    onSubmit={() =>
                                        navigate(
                                            `/templates/show/${template.id}`
                                        )
                                    }
                                    deletePattern={() =>
                                        deleteTemplate(template.id)
                                    }
                                    editPattern={() =>
                                        navigate(
                                            `/templates/edit/${template.id}`
                                        )
                                    }
                                />
                            ))
                        ) : (
                            <div className="flex justify-center p-4 text-sm">
                                no hay plantillas para mostrar
                            </div>
                        )}
                    </div>
                    <div className="flex justify-center mt-10">
                        <Pagination
                            totalPages={Math.ceil(
                                pagination.totalItems / pagination.itemsPerPage
                            )}
                            currentPage={pagination.page}
                            onPageChange={changePage}
                        />
                    </div>
                </div>
            </Box>
        </div>
    )
}
